// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Xp-z","slideIn":"Yp-z"};